module.exports = __webpack_public_path__ + "static/52-5b3dcc678cd0724f0234a07ad2f8add3.png";